<template>
  <div class="">
    <v-header :inputName='Name'></v-header>
    <div class="beijngsd" style="margin-bottom: 15px;">
      <span></span>
      {{NEWSTYPEOBJ[typeid]}}
      <span></span>
    </div>
    <div class="main centen container">
      <div  class="mzixunLeft">
        <h2>{{news.newsTitle}}</h2>
        <!-- pc端 -->
        <div class="biaoqian" style="justify-content: flex-end;">
          {{news.newsReleaseTime}}<span>|</span>
          <img src="../../assets/img/img1.png">{{news.newsClick}}
        </div>
        <div class="text">
          <div v-html="htmlNodes"> </div>
          <!-- <div class="biaoqiand">
            <img src="../../assets/img/imgs2.png">
            <img src="../../assets/img/imgs4.png">
            <img src="../../assets/img/imgs1.png">
            <img src="../../assets/img/imgs3.png">
            <img src="../../assets/img/imgs5.png">
          </div> -->
        </div>
      </div>
      <div class="mzixunRight" style="margin-top: 40px;">
        <div class="mzixunWenda">
          <div class="mzixunTitle flex-between">
            <h4>{{NEWSTYPEOBJ[typeid]}}</h4>
            <router-link :to="{path:'/newList'+type,query:{Name:Name,typeid:typeid,type:type}}" class="open">查看更多</router-link>
          </div>
          <ul class="mwendaList">
            <li v-for="(item,index) in list">
              <span>{{index+1}}</span>
              <router-link :to="{path:'/newsDetail',query:{id:item.newsId,Name:Name,typeid:typeid,type:type}}">{{item.newsTitle}}</router-link>
            </li>
          </ul>
        </div>

      </div>
      <zuoxuanfu1></zuoxuanfu1>
    </div>
    <item7></item7>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import zuoxuanfu1 from '../../components/zuoxuanfu1.vue'
  import item7 from '../../components/item7.vue'
  // import "../../css/reset.css"
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      zuoxuanfu1
    },
    data() {
      return {
        // 导航选中
        Name: 5,
        news:{},
        htmlNodes:'',
        NEWSTYPEOBJ:this.$utils.getlocalStorage('NEWSTYPEOBJ'),
        typeid:0,
        type:'gkzx',
        list:[]
      }
    },
    watch: {
      '$route.query.id': function(vl) {
        this.getNewDetail()
      }
    },
    created() {
      this.getNewDetail();
    },

    methods: {
      getNewDetail(){
        let _this = this;
        if(this.$route.query.Name!=null){
          this.Name = parseInt(this.$route.query.Name)
        }
        this.typeid = this.$route.query.typeid
        this.type = this.$route.query.type
        console.log(this.$route.query.id)
        this.$req.selectOne('newsTable', {
          id: this.$route.query.id
        }).then(function(response) {
          _this.news = response.data
          _this.getDetail();
          _this.getData();
        })
      },
      getDetail() {
        let _this = this;
        _this.$http.get(_this.$resourcesUrl + this.news.newsContent + "?time=" + new Date().getTime()).then(function(
          response) {
          _this.htmlNodes = response;

        })
      },
      getData() {
        let _this = this;
        let newsArea = 990000
        if(this.userInfo!=null){
          newsArea = this.userInfo.userProvinces
        }
        this.$req.queryAllByLimit("newsTable", {
          pageSize: 10,
          pageNum: 1,
          queryObj: {
            newsTypeId: this.typeid,
            newsArea:newsArea
          }
        }).then(function(response) {
          _this.list = response.data
        })
      }
    }


  }
</script>

<style scoped>
  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 70px;
    height: 100px;
    background: url(../../assets/img/img2.png)no-repeat;
    background-size: 100% 100%;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
  }
  .mzixunLeft{
    width: 930px;
    padding-right: 40px;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .main h2 {
    text-align: center;
    font-size: 34px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }

  .biaoqian {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #AAA9A9;
    margin-top: 40px;
  }

  .biaoqian span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #AAA9A9;
    margin: 0 15px;
  }

  .biaoqian img {
    width: 27px;
    height: 18px;
  }

  .text {
    margin-top: 32px;
  }

  .text p {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .juli {
    margin-top: 30px;
  }

  .biaoqiand {
    margin-top: 57px;
    margin-bottom: 20px;
  }

  .biaoqiand img {
    height: 25px;
    margin: 0 5px;
    cursor: pointer;
  }

  .botton {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .botton .botton_l {
    display: flex;
    flex-direction: column;
  }

  .botton .botton_l li {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #787878;
    cursor: pointer;
  }

  .botton .botton_l li:nth-of-type(1) {
    margin-bottom: 15px;
  }

  .botton .botton_l li span {
    color: #333333;
    font-family: MicrosoftYaHei;
    font-weight: Regular;
  }

  .botton .botton_r {
    width: 97px;
    height: 33px;
    background-color: #29A7E1;
    text-align: center;
    line-height: 33px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  @media (max-width:1400px) {
    .centen {
      width: auto;
    }

    .main {
      margin-top: 20px;
    }

    /* 右边固定 */

  }

  @media (min-width:750px) {
    .biaoqian2 {
      display: none;
    }

    .botton2 {
      display: none;
    }
  }

  @media (max-width:750px) {
    .biaoqian {
      display: none;
    }

    .zuotab {
      display: none;
    }

    .beijngsd {
      height: 70px;
      font-size: 24px;
    }

    .main h2 {
      font-size: 22px;
    }

    .biaoqian2 {
      display: flex;
      align-items: center;
      flex-direction: column;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #AAA9A9;
      margin-top: 10px;
    }

    .biaoqian2 .biaoqian2_top {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 5px;
    }

    .biaoqian2 .biaoqian2_top span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #AAA9A9;
    }

    .biaoqian2 .biaoqian2_top span img {
      width: 27px;
      height: 18px;
    }

    .text {
      margin-top: 20px;
    }

    .juli {
      margin-top: 15px;
    }

    .biaoqiand {
      margin-top: 30px;
    }

    .botton {
      display: none;
    }

    .botton2 {
      width: 100%;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .botton2 .botton_r2 {
      width: 97px;
      height: 33px;
      background-color: #29A7E1;
      text-align: center;
      line-height: 33px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      border-radius: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/news/newsDetail.vue